<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="goBack()">
        <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ 'Enquiries' | translate }}</ion-title>
    <ion-progress-bar *ngIf="isLoading" type="indeterminate"></ion-progress-bar>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">

  <ion-refresher slot="fixed" (ionRefresh)="handleRefresh($event)">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>

  <div class="enquiry-container">

    <div class="day-picker-wrapper" *ngIf="displayDates.length">
      <div class="day-picker">
        <div class="wrapper">

          <div class="ion-activatable ripple-parent day" [class.active]="displayDate.isActive" (click)="selectDays(displayDate.date)"
            *ngFor="let displayDate of displayDates">
            <ion-ripple-effect></ion-ripple-effect>
            <p>{{ displayDate.date | localeDate:locale:'MMM' }}</p>
            <p>{{ displayDate.date | date: 'dd' }}</p>
          </div>

          <div class="ion-activatable ripple-parent day" [class.active]="additionalMonths.isActive" (click)="selectMonths(i)"
            *ngFor="let additionalMonths of additionalDisplayMonths; let i = index">
            <ion-ripple-effect></ion-ripple-effect>
            <p>{{ additionalMonths.monthCount }}</p>
            <p>{{ 'month' | translate }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="enquiry-group-wrapper" rotaAnimate [animationShowTransitionMS]="300" [animateToggle]="(userApplicationGroups | async).length">
      <div class="enquiry-group" *ngFor="let userAppGroup of userApplicationGroups | async">
        <span class="status-label">{{ userAppGroup.status }}</span>

        <div class="enquiry-cards">
          <div [class]="'ion-activatable ripple-parent enquiry-card ' + getType(userApp.status)" *ngFor="let userApp of userAppGroup.userApplications"
            (click)="openChat(userApp)">
            <ion-ripple-effect></ion-ripple-effect>

            <div class="content-container">
              <div class="icon-wrapper">
                <ion-icon class="status" [name]="userAppGroup.icon"></ion-icon>
              </div>

              <div class="content-wrapper">
                <div class="header">
                  <h4 class="label">{{ userApp.application.title }}</h4>

                  <div class="date-wrapper">
                    <ion-icon *ngIf="!userApp.isRead" class="icon-status new-message" name="mail"></ion-icon>
                    <ion-icon *ngIf="userApp.isRead" class="icon-status" name="mail-open-outline"></ion-icon>
                    <p class="date">{{ userApp.application.createdAt | date: 'dd.MM.yyyy' }}</p>
                  </div>
                </div>

                <div class="message-preview">
                  <p class="text" [class.not-read]="!userApp.isRead" [class.two-line]="true" [class.muted]="true">
                    {{ userApp.application.description }}
                  </p>
                </div>
              </div>

              <div class="arrow-wrapper">
                <ion-icon name="chevron-forward" />
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <ion-button *ngIf="showLoadButton" class="load-more-button" (click)="loadMoreApplications()">
      <ion-icon slot="start" name="add-circle-outline"></ion-icon>
      {{ 'Show_More' | translate }}
    </ion-button>

    <div class="ion-text-center" *ngIf="showLoadButton">
      <ion-button color="light" (click)="loadMoreApplications()">
        <ion-icon slot="start" name="add-circle-outline"></ion-icon>
        {{ 'Show_More' | translate }}
      </ion-button>
    </div>

  </div>
</ion-content>